export const GET_CURRENT_VOLUNTEER_PROFILE = 'GET_CURRENT_VOLUNTEER_PROFILE'
export const GET_VOLUNTEER_FAVORITES_MISSION = 'GET_VOLUNTEER_FAVORITES_MISSION'
export const DELETE_MISSION_FROM_FAVORITES = 'DELETE_MISSION_FROM_FAVORITES'
